module.exports = __webpack_public_path__ + "static/img/nancy.c43719f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/nancy.jpg
// module id = 211
// module chunks = 1